import { Box, Button, useColorMode } from "@chakra-ui/react";
import {
  BodySize,
  BodyText,
  FWeight,
} from "theme/old-design-system/styled-components";
import { PaymentStatus } from "entities/domain/payments/payment-domain";
import useCustomChakraTheme from "hooks/use-custom-chakra-theme";
import usePaymentsStore from "hooks/use-payments-store";
import React, { useEffect, useRef, useState } from "react";
import CancelPaymentModal from "./cancelPayment";
import EditPaymentModal from "./editPayment";

const MoreActions = () => {
  const { editPayment, selectedPayment } = usePaymentsStore();
  const { colorMode } = useColorMode();
  const { colorScheme } = useCustomChakraTheme();
  const [cancelPaymentOpen, setCancelPaymentOpen] = useState<boolean>(false);
  const [editPaymentOpen, setEditPaymentOpen] = useState<boolean>(false);

  const cancelPayment = () => {
    editPayment({
      id: selectedPayment?.id,
      status: PaymentStatus.CANCELED,
      payment_method: undefined,
    });
    setCancelPaymentOpen(false);
  };

  return (
    <>
      <Box>
        {selectedPayment?.canBeMarkedAsPaid() && (
          <Button
            colorScheme={colorScheme}
            variant="ghost"
            onClick={() => setEditPaymentOpen(true)}
            w="100%"
            _hover={{ backgroundColor: "inherit", opacity: 0.5 }}
          >
            <BodyText size={BodySize.THREE} fweight={FWeight.TWO}>
              Mark as paid
            </BodyText>
          </Button>
        )}

        {selectedPayment?.canBeCancelled() && (
          <Button
            colorScheme={colorScheme}
            variant="ghost"
            onClick={() => setCancelPaymentOpen(true)}
            w="100%"
            _hover={{ backgroundColor: "inherit", opacity: 0.5 }}
          >
            <BodyText size={BodySize.THREE} fweight={FWeight.TWO}>
              Cancel payment request
            </BodyText>
          </Button>
        )}
        {selectedPayment?.canDownloadAnInvoice() && (
          <Button
            colorScheme={colorScheme}
            variant="ghost"
            w="100%"
            _hover={{ backgroundColor: "inherit", opacity: 0.5 }}
          >
            <a href={selectedPayment?.invoiceUrl} download>
              <BodyText size={BodySize.THREE} fweight={FWeight.TWO}>
                Download Invoice
              </BodyText>
            </a>
          </Button>
        )}

        <CancelPaymentModal
          isCancelPaymentsOpen={cancelPaymentOpen}
          onCancelPayment={cancelPayment}
          onClose={() => setCancelPaymentOpen(false)}
        />
        <EditPaymentModal
          isEditPaymentsOpen={editPaymentOpen}
          onClose={() => setEditPaymentOpen(false)}
        />
      </Box>
    </>
  );
};

export default MoreActions;
